import { Box, Typography, Avatar } from "@mui/material";
import { getPlatformIcon } from "../../_helpers/reusablefunctions/platformIconMapper";

const PlatformIconList = ({ platforms = [] ,showLabel = true}) => {
    if (!Array.isArray(platforms) || platforms.length === 0) {
        return (
            <Typography sx={{ fontSize: 13, color: "#9CA3AF" }}>
                No Platform
            </Typography>
        );
    }

    return (
        <Box sx={{ display: "flex", alignItems:'center' , gap:1,  flexWrap: "wrap", mt: 0.5 }}>
            {showLabel && (<Typography sx={{fontSize:'12px' , color:'#7A7A7A' , fontWeight:500}}>Platforms :</Typography>)}
            {platforms.map((p) => (
                <Box
                    key={p.platformId}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        // gap: 0.5,
                        // border: "1px solid #E5E7EB",
                        // borderRadius: "20px",
                        // paddingRight: '8px',
                        py: 0.3,
                        background: "#fff",
                    }}
                >
                    <Avatar
                        src={getPlatformIcon(p.platformName)}
                        alt={p.platformName}
                        sx={{ width: 26, height: 26 }}
                    // variant="square"
                    />
                    {/* <Typography sx={{ fontSize: 12, fontWeight: 500 }}>
            {p.platformName}
          </Typography> */}
                </Box>
            ))}
        </Box>
    );
};

export default PlatformIconList;
